import { UPDATE_EXPERIMENTS } from '../actions/config';
import DEFAULT_STATE, { ConfigState } from '../defaults/config';
import createReducer from './create-reducer';

function updateExperiments(
  state: ConfigState,
  { payload }: { payload: ConfigState['experiments'] },
) {
  return {
    ...state,
    experiments: {
      ...state.experiments,
      ...payload,
    },
  };
}

export default createReducer(DEFAULT_STATE, {
  [UPDATE_EXPERIMENTS]: updateExperiments,
});
